import axios from "axios";

class ActivityLogsFilterModel {
    actionName: null;
    appName: number;
    insertDate: null;
    metrics: null;
    getResult = () => {
        return {
            appName: this.appName,
            actionName: this.actionName,
            insertDate: this.insertDate,
            metrics: this.metrics
        }
    }
    static getApiFilter = async () => {
        return (await axios.get(`/api/logs/FilterSelected`)).data;
    }
}
export default ActivityLogsFilterModel
